@if (noticeSession && !hiddenByFloating) {
	<ng-container *permissions="'dispute.session.read'">
		<!--
			Montado mesmo fechado (29/09/2026): o chat segue conectado, conta o que chega para o badge e, ao
			reabrir, a conversa está onde parou. Fechado, só sai de vista — e da navegação por teclado.
		-->
		<section
			id="notice-session-chat-balloon"
			class="chat-balloon"
			[class.chat-balloon--hidden]="!open"
			[attr.aria-hidden]="!open"
			role="dialog"
			aria-label="Chat da sessão">
			<app-notice-session-chat
				[noticeSession]="noticeSession"
				[balloon]="true"
				(closed)="close()"
				(messageReceived)="onMessageReceived()"></app-notice-session-chat>
		</section>
		<button
			type="button"
			class="chat-launcher btn btn-primary rounded-circle"
			[class.chat-launcher--open]="open"
			[attr.aria-expanded]="open"
			aria-controls="notice-session-chat-balloon"
			[attr.aria-label]="buttonLabel"
			[ngbTooltip]="open ? 'Fechar chat' : 'Chat da sessão'"
			triggers="hover"
			placement="start"
			container="body"
			(click)="toggle()">
			<fa-icon [icon]="open ? 'xmark' : 'comments'" size="lg"></fa-icon>
			@if (!open && unreadCount > 0) {
				<span class="chat-launcher__badge" aria-hidden="true">{{ unreadLabel }}</span>
			}
		</button>
	</ng-container>
}
